import { __assign, __awaiter, __generator } from "tslib";
export var mergeHeaders = function (h1, h2) {
    return __assign(__assign({}, (h1 || {})), (h2 || {}));
};
export var addDefaultHeaders = function (http, headersFetcher, errorHandler) {
    var fetchAndMerge = function (headers) { return __awaiter(void 0, void 0, void 0, function () {
        var defaultHeaders;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, headersFetcher()];
                case 1:
                    defaultHeaders = _a.sent();
                    return [2 /*return*/, mergeHeaders(defaultHeaders, headers)];
            }
        });
    }); };
    var handleErrors = function (e) {
        var defaultPrevented = false;
        // tslint:disable-next-line:prefer-object-spread
        var extendedError = Object.assign(e, { preventDefaultErrorHandler: function () { return defaultPrevented = true; } });
        setTimeout(function () {
            if (!defaultPrevented && errorHandler) {
                errorHandler(e);
                return e;
            }
        });
        throw extendedError;
    };
    return {
        get: function (url, headers) { return __awaiter(void 0, void 0, void 0, function () {
            var mergedHeaders;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchAndMerge(headers)];
                    case 1:
                        mergedHeaders = _a.sent();
                        return [2 /*return*/, http.get(url, mergedHeaders).then(function (res) { return res; }).catch(handleErrors)];
                }
            });
        }); },
        post: function (url, body, headers, onUploadProgress) { return __awaiter(void 0, void 0, void 0, function () {
            var mergedHeaders;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchAndMerge(headers)];
                    case 1:
                        mergedHeaders = _a.sent();
                        return [2 /*return*/, http.post(url, body, mergedHeaders, onUploadProgress).then(function (res) { return res; }).catch(handleErrors)];
                }
            });
        }); },
        delete: function (url, headers) { return __awaiter(void 0, void 0, void 0, function () {
            var mergedHeaders;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchAndMerge(headers)];
                    case 1:
                        mergedHeaders = _a.sent();
                        return [2 /*return*/, http.delete(url, mergedHeaders).then(function (res) { return res; }).catch(handleErrors)];
                }
            });
        }); },
        put: function (url, body, headers, onUploadProgress) { return __awaiter(void 0, void 0, void 0, function () {
            var mergedHeaders;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchAndMerge(headers)];
                    case 1:
                        mergedHeaders = _a.sent();
                        return [2 /*return*/, http.put(url, body, mergedHeaders, onUploadProgress).then(function (res) { return res; }).catch(handleErrors)];
                }
            });
        }); }
    };
};
//# sourceMappingURL=utils.js.map